<template>
  <div :class="[tooltip != null ? 'tooltip' : '']" :data-tip="tooltip">
    <button
      @click="backend.createNewConfig"
      class="btn btn-accent w-24"
      :disabled="backend.currentConfig == null || error != null"
    >
      New
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";

const backend = useBackendStore();

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.userLoggedIn) {
    return "Log in to create configurations";
  }
  if (
    backend.configList.filter(
      (c) =>
        c.owner == backend.currentConfig?.owner &&
        c.name == backend.currentConfig?.name
    ).length > 0
  ) {
    return "Configuration with this name already exists";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Save as new configuration";
});
</script>
